module.exports = __webpack_public_path__ + "img/logo_big.500cb42e.png";